(function () {
  'use strict';

  var STORAGE_KEY = 'aelo_referral_attribution_v1';
  var MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;
  var CODE_RE = /^[A-Z0-9]{6,16}$/;
  var syncPromise = null;
  var lastSyncedCode = null;

  function normalizeCode(raw) {
    if (typeof raw !== 'string') return null;
    var normalized = raw.trim().toUpperCase().replace(/[\s-]+/g, '');
    return CODE_RE.test(normalized) ? normalized : null;
  }

  function readStored(now) {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var stored = JSON.parse(raw);
      var code = normalizeCode(stored && stored.code);
      var capturedAt = Number(stored && stored.capturedAt);
      if (!code || !Number.isFinite(capturedAt) || capturedAt <= 0 || now - capturedAt > MAX_AGE_MS) {
        window.localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return { code: code, capturedAt: capturedAt };
    } catch (_) {
      return null;
    }
  }

  function captureFromLocation(now) {
    var params = new URLSearchParams(window.location.search);
    var code = normalizeCode(params.get('aelo_ref') || params.get('code') || params.get('invite'));
    if (!code) return readStored(now);

    var attribution = { code: code, capturedAt: now };
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(attribution));
    } catch (_) {
      // Cart attributes still preserve this visit when storage is unavailable.
    }
    return attribution;
  }

  function syncCartAttributes(attribution) {
    if (!attribution) return Promise.resolve(false);
    if (syncPromise && lastSyncedCode === attribution.code) return syncPromise;
    lastSyncedCode = attribution.code;

    syncPromise = fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart/update.js'
      : '/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          '__aelo_referral_code': attribution.code,
          '__aelo_referral_captured_at': new Date(attribution.capturedAt).toISOString(),
          '__aelo_referral_model': 'last_valid_click_30d'
        }
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('cart_attribute_sync_failed');
      return true;
    }).catch(function () {
      return false;
    });

    return syncPromise;
  }

  function buildAttributedUrl(href, attribution) {
    if (!attribution || !href) return href;
    try {
      var url = new URL(href, window.location.origin);
      if (url.protocol !== 'http:' && url.protocol !== 'https:') return href;
      var allowedHosts = [
        window.location.hostname,
        'aelofilter.com',
        'www.aelofilter.com',
        'shop.aelofilter.com'
      ];
      if (allowedHosts.indexOf(url.hostname) === -1) return href;
      if (url.pathname.indexOf('/checkout') === 0) return href;
      if (!url.searchParams.get('aelo_ref')) {
        url.searchParams.set('aelo_ref', attribution.code);
      }
      if (url.origin !== window.location.origin) return url.toString();
      return url.pathname + url.search + url.hash;
    } catch (_) {
      return href;
    }
  }

  function decorateInternalLinks(attribution) {
    if (!attribution || !document.querySelectorAll) return;
    var links = document.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i += 1) {
      var link = links[i];
      var href = link.getAttribute('href');
      if (!href || href.charAt(0) === '#' || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0 || href.indexOf('sms:') === 0) continue;
      var nextHref = buildAttributedUrl(href, attribution);
      if (nextHref !== href) link.setAttribute('href', nextHref);
    }
  }

  function decorateFreshLinks() {
    decorateInternalLinks(captureFromLocation(Date.now()));
  }

  function resyncCart(attribution) {
    syncPromise = null;
    return syncCartAttributes(attribution);
  }

  var attribution = captureFromLocation(Date.now());
  decorateInternalLinks(attribution);
  window.setTimeout(decorateFreshLinks, 500);
  window.setTimeout(decorateFreshLinks, 1500);
  window.setTimeout(decorateFreshLinks, 3500);

  if (window.MutationObserver && document.documentElement) {
    var decorateTimer = null;
    var observer = new MutationObserver(function () {
      if (decorateTimer) window.clearTimeout(decorateTimer);
      decorateTimer = window.setTimeout(decorateFreshLinks, 120);
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['href']
    });
  }

  document.addEventListener('submit', function (event) {
    var target = event.target;
    if (!target || !target.matches || !target.matches('form[action*="/cart/add"]')) return;
    void resyncCart(attribution);
  }, true);

  window.addEventListener('pageshow', function () {
    var fresh = captureFromLocation(Date.now());
    decorateInternalLinks(fresh);
    void resyncCart(fresh);
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'visible') return;
    void resyncCart(captureFromLocation(Date.now()));
  });

  window.AeloReferralAttribution = Object.freeze({
    code: attribution ? attribution.code : null,
    capturedAt: attribution ? attribution.capturedAt : null,
    ready: syncCartAttributes(attribution),
    refresh: function () {
      return resyncCart(captureFromLocation(Date.now()));
    }
  });
})();
